import { render, staticRenderFns } from "./IpiSimplesNacional.vue?vue&type=template&id=8e573024&scoped=true&"
import script from "./IpiSimplesNacional.vue?vue&type=script&lang=js&"
export * from "./IpiSimplesNacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e573024",
  null
  
)

export default component.exports